/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyClassificationQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyClassificationQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyClassificationQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyClassificationQueryOperator>): PolicyClassificationQueryOperator {
        let obj = Object.assign(new PolicyClassificationQueryOperator(), model);
        PolicyClassificationQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyClassificationQueryOperator>): PolicyClassificationQueryOperator {
        if (!model) return null;
        return PolicyClassificationQueryOperator.newInstance(<PolicyClassificationQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyClassificationQueryOperator) {
        if (!obj) return;

        models.PolicyClassificationQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyClassificationQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyClassificationQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy classifications to include
     */
    classifications: Array<models.PolicyClassification>;

}
